import React from "react"
import { GatsbyImage } from "gatsby-plugin-image"
import styled from "styled-components"
import Slider from "react-slick"
import { theme } from "Theme"
import { Gap, Brands } from "Styles"

const Wrapper = styled.div`
  color: ${(props) => (props.dark ? theme.colors.black.base : theme.colors.white.base)};
  min-height: ${(props) => (props.big ? "400px;" : "100px;")};
  background-color: ${(props) => (props.dark ? theme.colors.background.black : theme.colors.white.base)};
  color: ${(props) => (props.dark ? theme.colors.white.base : theme.colors.black.base)};
  border-color: ${(props) => (props.dark ? theme.colors.white.base : theme.colors.black.base)};
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column-reverse;

  align-items: center;
  margin: 0 auto;
  @media (min-width: ${theme.breakpoints.s}) {
  }
  @media (min-width: ${theme.breakpoints.m}) {
    flex-direction: row;
    margin: 0 auto 0;
  }
  @media (min-width: ${theme.breakpoints.l}) {
  }
`

const Content = styled.div`
  display: block;
  margin: 0 auto;
  text-align: center;
  width: 100%;
  @media (min-width: ${theme.breakpoints.s}) {
  }
  @media (min-width: ${theme.breakpoints.m}) {
  }
  @media (min-width: ${theme.breakpoints.l}) {
  }
`

const Grid = styled.div`
  margin: 0 auto;
  width: 100%;
  max-width: ${theme.layout.base};
`

const BrandsStrip = ({ brands, big, dark, title, subtitle }) => {
  const settings = {
    dots: false,
    arrows: false,
    pauseOnHover: false,
    infinite: true,
    autoplay: true,
    speed: 4000,
    autoplaySpeed: 1000,
    cssEase: "linear",
    slidesToShow: 6,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1240,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 400,
        settings: {
          dots: true,
          slidesToShow: 1,
          speed: 6000,
        },
      },
    ],
  }
  return (
    <>
      <Wrapper dark={dark ? 1 : undefined} big={big}>
        <Content dark={dark ? 1 : undefined}>
          <Wrapper>
            <Grid>
              {title && (
                <>
                  <Gap />
                  <Brands.Title>{title}</Brands.Title>
                </>
              )}
              {subtitle && <Brands.Subtitle>{subtitle}</Brands.Subtitle>}
              <Slider {...settings} slickPlay>
                {brands.map((brand, i) => {
                  return (
                    <Brands.Card key={i}>
                      <Brands.Logo>
                        <GatsbyImage
                          imgStyle={{ height: "auto" }}
                          alt={`${brand.node.name} Logo`}
                          title={`${brand.node.name} Logo`}
                          image={brand.node.childrenFile[0].childImageSharp.gatsbyImageData}
                          objectFit="contain"
                        />
                      </Brands.Logo>
                    </Brands.Card>
                  )
                })}
              </Slider>
            </Grid>
          </Wrapper>
        </Content>
      </Wrapper>
    </>
  )
}

export default BrandsStrip
